var map = {
	"./apps/ai/manager/chainInstance/chainInstance.saga.js": 952,
	"./apps/combinedContextLoader/combinedContextLoader.saga.js": 1261,
	"./apps/dashboard/actionlist/actionlist.saga.js": 1262,
	"./apps/projectManagement/addProjectModal/addProjectModal.saga.js": 1263,
	"./apps/workflow/headingWorkflow/headingWorkflow.saga.js": 1264,
	"./apps/workflow/schemaBasedEditor/schemaBasedEditor.saga.js": 1265,
	"./apps/workflow/workflowEditor/document/documentWorkflowEditor.saga.js": 1266,
	"./apps/workflow/workflowEditor/heading/headingWorkflowEditor.saga.js": 1267,
	"./apps/workflow/workflowWidget/components/approvalHistoryModal/approvalHistoryModal.saga.js": 1268,
	"./apps/workflow/workflowWidget/workflowWidget.saga.js": 981,
	"./contexts/account/account.saga.js": 1269,
	"./contexts/document/document.saga.js": 1270,
	"./contexts/heading/heading.saga.js": 1271,
	"./contexts/instance/instance.saga.js": 1272,
	"./contexts/organisation/organisation.saga.js": 1273,
	"./contexts/project/dataTypes/groups/groups.saga.js": 1274,
	"./contexts/project/dataTypes/users/users.saga.js": 982,
	"./contexts/project/project.saga.js": 1275,
	"./contexts/workflowinstance/workflowinstance.saga.js": 1276,
	"./globals/dataTypes/auth/auth.saga.js": 983,
	"./globals/dataTypes/comments/comments.saga.js": 1277,
	"./globals/dataTypes/login/login.saga.js": 352,
	"./globals/dataTypes/maintenance/data/data.saga.js": 1278,
	"./globals/dataTypes/notificationSettings/notificationSettings.saga.js": 984,
	"./globals/dataTypes/notifications/notifications.saga.js": 985,
	"./globals/dataTypes/performanceLogs/performanceLogs.saga.js": 1279,
	"./globals/dataTypes/projects/projects.saga.js": 1280,
	"./globals/dataTypes/workflow/workflowEditor/workflowEditor.saga.js": 1281,
	"./globals/dataTypes/workflow/workflowTasks/workflowTasks.saga.js": 986,
	"./globals/global.saga.js": 987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 951;